import sercue from "@/assets/clients/sercue.jpg";
import atwima from "@/assets/clients/atwima.png";
import agrocrown from "@/assets/clients/agrocrown.png";
import wran from "@/assets/clients/wran.png";
import barrowHammer from "@/assets/clients/barrow-hammer.png";
import enam from "@/assets/clients/enam.jpg";
import comfee from "@/assets/clients/comfee.png";
import runbal from "@/assets/clients/runbal.png";
import hanybels from "@/assets/clients/hanybels.jpg";
import ubumwe from "@/assets/clients/ubumwe.jpg";
import agronovi from "@/assets/clients/agronovi.jpg";
import astrapos from "@/assets/clients/astrapos.jpg";
import jsk from "@/assets/clients/jsk.jpg";
import igflink from "@/assets/clients/igflink.jpg";
import kuntany from "@/assets/clients/kuntany.jpg";
import { Section, SectionHeading } from "@/components/site/Layout";

const logos = [
  { src: agrocrown, alt: "AgroCrown" },
  { src: atwima, alt: "Atwima Kwanwoma District Assembly" },
  { src: sercue, alt: "Sercue" },
  { src: wran, alt: "Western Region Association of Nurses UK" },
  { src: barrowHammer, alt: "Barrow & Hammer Developers" },
  { src: enam, alt: "Enam Cosmetics" },
  { src: comfee, alt: "Comfee" },
  { src: runbal, alt: "RunBal Consulting" },
  { src: hanybels, alt: "Hanybels Plush" },
  { src: ubumwe, alt: "Ubumwe Care and Psych Consult" },
  { src: agronovi, alt: "Agronovi" },
  { src: astrapos, alt: "AstraPos" },
  { src: jsk, alt: "J&K Accounting & Advisory Services" },
  { src: igflink, alt: "IGFLink" },
  { src: kuntany, alt: "Kuntany Auto Decoration" },
];

export function ClientsMarquee() {
  // Triple the set so the -50% loop stays fully populated across wide viewports.
  const loop = [...logos, ...logos, ...logos];
  return (
    <Section>
      <SectionHeading eyebrow="Trusted by" title="Clients and Partners" />
      <div className="relative overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_6%,black_94%,transparent)]">
        <div className="flex w-max animate-marquee py-4 sm:py-6">
          {loop.map((l, i) => (
            <a
              key={i}
              href="/case-studies"
              aria-label={l.alt}
              className="flex h-20 w-32 shrink-0 items-center justify-center px-3 sm:h-24 sm:w-40 sm:px-4 md:h-28 md:w-48 md:px-5 lg:h-32 lg:w-56 lg:px-6"
            >
              <img
                src={l.src}
                alt={l.alt}
                className="max-h-full max-w-full object-contain opacity-80 transition hover:opacity-100"
                loading="lazy"
              />
            </a>
          ))}
        </div>
      </div>
    </Section>
  );
}
